import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import { DatePicker } from 'antd';
import 'antd/dist/antd.css';

import Result from 'antd/lib/result';
import Progress from 'antd/lib/progress';
import List from 'antd/lib/list';
import Card from 'antd/lib/card';
import Avatar from 'antd/lib/avatar';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';

import moment from 'moment';
import 'moment/locale/el';

import { bind, isFunc, isNil } from 'vdlib';

class Overview extends React.Component {
  constructor(props) {
    super(props);

    bind(this, ['onHide', 'populate']);

    moment.locale('gr');
    this.populate(props);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentDidUpdate(prevProps) {
    this.populate(prevProps);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onHide() {
    if (isFunc(this.props.onHide)) {
      this.props.onHide();
    }
  }

  populate(props) {
    if (isNil(props)) props = this.props;
  }

  render() {
    const { data, error, totalEstimations } = this.props;

    return (
      <div>
        {error ? (
          <Result
            status="warning"
            title="There are some problems with your operation."
          />
        ) : (
          <List
            grid={{ gutter: 8, column: 3 }}
            dataSource={data}
            renderItem={item => (
              <List.Item>
                <Card
                  title={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        <Avatar
                          size="large"
                          style={{
                            marginRight: 10,
                            color: '#f56a00',
                            backgroundColor: '#fde3cf',
                          }}
                        >
                          {item.Insurance.substring(0, 1)}
                        </Avatar>
                        <span>{item.Insurance}</span>
                      </div>
                      <span style={{ marginTop: 5 }}>{`${
                        item.Estimations.length
                      }/${totalEstimations || 0}`}</span>
                    </div>
                  }
                >
                  {`Συνολικές νέες εκτιμήσεις: ${item.Estimations.length} `}
                  <div>
                    <Row>
                      <Col span={8}>
                        <span>Pending:</span>
                      </Col>
                      <Col span={16}>
                        <Progress
                          strokeColor={'#F1C40F'}
                          format={percent => (
                            <span style={{ color: '#F1C40F' }}>{`${
                              item.Estimations.filter(x => x.StatusID === 5)
                                .length
                            }/${item.Estimations.length}`}</span>
                          )}
                          percent={parseInt(
                            (item.Estimations.filter(x => x.StatusID === 5)
                              .length /
                              item.Estimations.length) *
                              100
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <span>Processed:</span>
                      </Col>
                      <Col span={16}>
                        <Progress
                          strokeColor={'#337AB7'}
                          format={percent => (
                            <span style={{ color: '#337AB7' }}>
                              {`${
                                item.Estimations.filter(x => x.StatusID === 1)
                                  .length
                              }/${item.Estimations.length}`}
                            </span>
                          )}
                          percent={parseInt(
                            (item.Estimations.filter(x => x.StatusID === 1)
                              .length /
                              item.Estimations.length) *
                              100
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <span>Processing:</span>
                      </Col>
                      <Col span={16}>
                        <Progress
                          strokeColor={'#BAC3D0'}
                          format={percent => (
                            <span style={{ color: '#BAC3D0' }}>
                              {`${
                                item.Estimations.filter(x => x.StatusID === 6)
                                  .length
                              }/${item.Estimations.length}`}
                            </span>
                          )}
                          percent={parseInt(
                            (item.Estimations.filter(x => x.StatusID === 6)
                              .length /
                              item.Estimations.length) *
                              100
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <span>Failed:</span>
                      </Col>
                      <Col span={16}>
                        <Progress
                          strokeColor={'#ED6B75'}
                          format={percent => (
                            <span style={{ color: '#ED6B75' }}>
                              {`${
                                item.Estimations.filter(
                                  x => x.StatusID === 2 || x.StatusID === 3
                                ).length
                              }/${item.Estimations.length}`}
                            </span>
                          )}
                          percent={parseInt(
                            (item.Estimations.filter(
                              x => x.StatusID === 2 || x.StatusID === 3
                            ).length /
                              item.Estimations.length) *
                              100
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <span>Small Damage:</span>
                      </Col>
                      <Col span={16}>
                        <Progress
                          strokeColor={'#36C6D3'}
                          format={percent => (
                            <span style={{ color: '#36C6D3' }}>
                              {`${
                                item.Estimations.filter(x => x.StatusID === 7)
                                  .length
                              }/${item.Estimations.length}`}
                            </span>
                          )}
                          percent={parseInt(
                            (item.Estimations.filter(x => x.StatusID === 7)
                              .length /
                              item.Estimations.length) *
                              100
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <span>Part Auctions:</span>
                      </Col>
                      <Col span={16}>
                        <Progress
                          strokeColor={'#36C6D3'}
                          format={percent => (
                            <span style={{ color: '#36C6D3' }}>
                              {`${
                                item.Estimations.filter(x => x.PartAuctionID)
                                  .length
                              }/${item.Estimations.length}`}
                            </span>
                          )}
                          percent={parseInt(
                            (item.Estimations.filter(x => x.PartAuctionID)
                              .length /
                              item.Estimations.length) *
                              100
                          )}
                        />
                      </Col>
                    </Row>
                  </div>
                </Card>
              </List.Item>
            )}
          />
        )}
      </div>
    );
  }
}
export default Overview;
